module.exports = __webpack_public_path__ + "img/mark_star_6_icon.5ef5f8f3.png";